export default __webpack_public_path__ + "static/media/gq.bb11dca8.svg";